import { Component, OnInit, PLATFORM_ID, Inject, Renderer2, ElementRef, ViewChild } from '@angular/core';
import { LinkService } from '../../_services/langhfre.service';
import { Title, Meta } from '@angular/platform-browser';
import { DOCUMENT, isPlatformServer } from '@angular/common';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomeComponent implements OnInit {

  constructor(
    private titleService: Title,
    private metaTagService: Meta,
    private LinkService: LinkService,
    // public amplitudeService: AmplitudeService,

  ) {
  }

  ngOnInit() {
    //this.initializeMoEngage();
    this.titleService.setTitle('Trinka: KI-Tool für Texte und Grammatik');
    this.metaTagService.updateTag({ name: 'description', content: "Verbessern Sie Ihre Texte und Ihre Grammatik mit einem KI-Schreibassistenten! Trinka optimiert Ihre Texte durch KI-gestützte Bearbeitung und Korrektur – für eine klare, prägnante und wirkungsvolle Kommunikation. Jetzt kostenlos testen!" });
    this.metaTagService.updateTag({ property: 'og:title', content: 'Trinka: KI-Tool für Texte und Grammatik' });
    this.metaTagService.updateTag({ property: 'og:description', content: 'Verbessern Sie Ihre Texte und Ihre Grammatik mit einem KI-Schreibassistenten! Trinka optimiert Ihre Texte durch KI-gestützte Bearbeitung und Korrektur – für eine klare, prägnante und wirkungsvolle Kommunikation. Jetzt kostenlos testen!' });
    this.metaTagService.updateTag({ property: 'og:url', content: 'https://www.trinka.ai/de/' });
    this.metaTagService.updateTag({ property: 'og:type', content: 'website' });
    this.metaTagService.updateTag({ property: 'og:image', content: 'https://www.trinka.ai/assets/images/Trinka.jpg' });
    this.metaTagService.updateTag({ name: 'language', content: 'en-us' });
    this.metaTagService.updateTag({ name: 'twitter:title', content: 'Trinka: KI-Tool für Texte und Grammatik' });
    this.metaTagService.updateTag({ name: 'twitter:description', content: "Verbessern Sie Ihre Texte und Ihre Grammatik mit einem KI-Schreibassistenten! Trinka optimiert Ihre Texte durch KI-gestützte Bearbeitung und Korrektur – für eine klare, prägnante und wirkungsvolle Kommunikation. Jetzt kostenlos testen!" });
    this.metaTagService.updateTag({ name: 'twitter:image', content: 'https://www.trinka.ai/assets/images/Trinka.jpg' });
    this.metaTagService.updateTag({ name: 'keywords', content: 'Ai writing assistant, ai proofreader, grammar checker, ai writing tool, free grammar checker, ai editing, ai content editing tool, grammar check, check grammar, grammar and syntax checker, grammar check online, verify grammar online, ai proofreading tool' });
    this.LinkService.addTag({ rel: 'canonical', href: 'https://www.trinka.ai/de/' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'x-default', href: 'https://www.trinka.ai' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'en-us', href: 'https://www.trinka.ai' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'de-de', href: 'https://www.trinka.ai/de/' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'ja-jp', href: 'https://www.trinka.ai/jp/' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'zh-cn', href: 'http://trinka.enago.cn' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'zh-tw', href: 'https://www.trinka.ai/tw/' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'ko-kr', href: 'https://www.trinka.ai/kr/' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'es-es', href: 'https://www.trinka.ai/es/' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'pt-pt', href: 'https://www.trinka.ai/pt/' });
    // this.amplitudeService.logAmplitude('home_page_view', {});
    //ire('identify', { 'customerId': '', customerEmail: '', customProfileId: '' });
  }
  
  activePanel: string | null = 'panel1';
  slideDir: string = '0px';

  togglePanel(el: HTMLElement, panelName: string, event: MouseEvent) {

    // Collapse if already active
    if (this.activePanel === panelName) {
      this.activePanel = null;
      return;
    }

    const rect = el.getBoundingClientRect();
    const clickX = event.clientX - rect.left;
    const midPoint = rect.width / 2;

    this.slideDir = clickX < midPoint ? '-40px' : '40px';

    this.activePanel = panelName;
  }


}
